import { FilterSearchingBaseViewModel, LoggedUserViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';
import { TwSolicitudCamViewModel } from '../../types/solicitudcam-datosbasicos.types';

export class SolicitudCamItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SolicitudCamItemResultViewModel[];
}

export class SolicitudCamItemResultViewModel {
    public Id?: number;
    public Codigo?: string;
    public Campania: string;
    public Periodo: string;
    public OperadorRazonSocial: string;
    public FechaCreacion?: Date;
    public FechaSolicitud?: Date;
    public EntidadAuditora: string;
    public DescripcionComunidad: string;
    public TipoSolicitudCam: string;
    public IdTipoSolicitudCam: number;
    public IdEstadoSolicitudCam?: number;
    public EstadoSolicitudCam?: string;
    public PeriodoPresentacionVigente: boolean; // Una plazo de presentación podrá estar vigente porque el día "en curso" esté dentro de las fechas FechaInicioPresentacion y FechaFinPresentacion, o porque el periodo tenga habilitado el parámetro "PresentarSolicitudesFueraPeriodo".
    public PeriodoVigente: boolean;
    public IdUsuario: number;
}

export class SolicitudCamItemViewModel extends TwSolicitudCamViewModel {
    public Campania: string;
    public Periodo: string;
    public DescripcionComunidad: string;
    public EntidadAuditora: string;
    public TipoSolicitudCam: string;
    public PeriodoPresentacionVigente: boolean; // Una plazo de presentación podrá estar vigente porque el día "en curso" esté dentro de las fechas FechaInicioPresentacion y FechaFinPresentacion, o porque el periodo tenga habilitado el parámetro "PresentarSolicitudesFueraPeriodo".
}

export class FilterSearchingSolicitudCam extends FilterSearchingBaseViewModel {
    public Activa?: boolean | number;
    public IdCampania?: number;
    public FechaInicioPresentacion?: Date;
    public FechaFinPresentacion?: Date;
    public Codigo: string;
    public IdPeriodo?: number;
    public IdCA?: number;
    public IdEntidadAuditora?: number;
    public IdTipoSolicitudCam?: number;
    public IdEstadoSolicitudCam?: number;
    public SoloDevueltas?: boolean | number; // Este campo se utiliza solamente en el front. No se envirá al core.
    public IdUsuario?: number; // Este campo no se rellena en el front. Se indica por compatibilidad de tipos con el core.
    public Operador: string;
}

export class PlazoActivoViewModel {
    public FechaInicioPresentacion?: Date;
    public FechaFinPresentacion?: Date;
}

export class PeriodoCamActivoViewModel {
    public IdPeriodo: number;
    public DescripcionPeriodo: string;
    public Plazos: PlazoActivoViewModel[];
    public DescripcionCampania: string;
    public HabilitadaTemporalmente: boolean;
    public PresentarSolicitudesFueraPeriodo: boolean;
    public AmbitoNacional: boolean;
    public FechaInicio: Date;
}

export class PeriodoTipoSolicitudViewModel {
    public IdTipoSolicitud: number;
    public Descripcion: string;
}

export class PeriodoDatosCaCamViewModel {
    public IdCa: number;
    public Id: number;
    public ComunidadAutonoma: string;
    public EntidadAuditora: boolean;
}

export class CASelectedViewModel {
    public idPeriodo?: number;
    public idCA?: number;
}

export class UserDataViewModel {
    public idUsuario: number;
    public isAdmin: boolean;
    public loggedInUser: LoggedUserViewModel;
    public idCA?: number;
    public isOperadorCam: boolean;
}

export class ActivaSelected {
    public Activa: number;
    public cleanDependent?: boolean;
}
